import { O_FETCH_SUGGESTIONS, O_FETCH_SEARCH } from './constants'

const initialState = {
  isFetching: false,
  isSearching: false,
  suggestions: [],
  searchResults: {},
  total: 0
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case O_FETCH_SUGGESTIONS.REQUEST: {
      return {
        ...state,
        isFetching: true
      }
    }
    case O_FETCH_SUGGESTIONS.SUCCESS: {
      return {
        ...state,
        isFetching: false,
        suggestions: action.results
      }
    }
    case O_FETCH_SEARCH.REQUEST: {
      return {
        ...state,
        isSearching: true
      }
    }
    case O_FETCH_SEARCH.SUCCESS: {
      return {
        ...state,
        isSearching: false,
        searchResults: action.searchResults
      }
    }
    default: {
      return state
    }
  }
}
